import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { count, isDefined } from "../config/helpers";
import authActions from "../Redux/Auth/actions";
import { CRM_URL, USER_ROUTE, USER_URL } from "modules/Auth/utilities/constants";
import useUserAccountAction, { ACTION_GROUPS, ENTITY_ACTIONS } from "modules/Auth/hooks/useUserAccountAction";

const useAuth = () => {
	const dispatch = useDispatch();
	const user = useSelector(state => state.authReducer.user);
	const system_preferences = useSelector(state => state.dashboardReducer?.system_preferences);
	const preferencesReady = user?.preferences?.preferencesReady || false;
	const systemPreferencesReady = system_preferences?.system_preferences_ready || false;
	const isAuthenticated = useSelector(state => state.authReducer.isAuthenticated);
	const linkedAccounts = useSelector(state => state.authReducer.linkedAccounts);
	const defaultAccount = linkedAccounts?.default || null;
	const agentReducer = useSelector((state) => state.agentReducer);
	const [selectedAccount, setSelectedAccount] = useState(null)
	const { trackAction } = useUserAccountAction();

	const isAgent = () => {
		if (agentReducer?.user_state == 'Agent' || agentReducer?.user_state == 'SuperUser') {
			return true;
		}
		else if (agentReducer?.user_state == 'User') {
			return false
		}
		else {
			return user.role == 'Agent' ? true : false;
		}
	}

	const is_agent = isAgent();

	const handleLogout = async () => {
		await trackAction({
			action_type: ENTITY_ACTIONS.LOGOUT,
			action_group: ACTION_GROUPS.AUTH,
			url: window.location.href,
		});
		dispatch({ type: authActions.AUTH_LOGOUT });

	}

	useEffect(() => {
		linkedAccounts && isDefined(linkedAccounts.all) && count(linkedAccounts.all) > 0 && isDefined(linkedAccounts.default) && count(Object.keys(linkedAccounts.default)) && (setSelectedAccount(linkedAccounts.default.CustomerID))
	}, [linkedAccounts])


	const hasDefaultAccount = () => {
		if (isDefined(user) && (!user?.has_default || user.has_default == 0)) {
			return false;
		}
		return true;
	}

	const openAccountModal = () => {
		dispatch({
			type: "CREATE_ACCOUNT_MODAL_TOGGLE",
			payload: true
		})
	}

	const resendVerificationLink = () => {
		dispatch({ type: authActions.AUTH_SEND_EMAIL_VERIFICATION_LINK, payload: user.email });
	}

	const handleRadioChange = (event) => {
		setSelectedAccount(event.target.value)
	}

	const submitDefaultAccount = () => {
		dispatch({ type: authActions.AUTH_SET_DEFAULT_ACCOUNT, payload: selectedAccount })
	}

	const getRoute = (type, id, mode) => {
		let baseRoute = is_agent ? CRM_URL : USER_URL;

		switch (type) {
			case 'order':
				if (is_agent) {
					return `${baseRoute}/order/${id}`;
				}
				else {
					return `${baseRoute}/orders/${id}`;
				}
			case 'quote':
				return `${baseRoute}/quote/${id}`;
			case 'quoteEditMode':
				return `${baseRoute}/quote/${id}?quickEdit=${mode}`;
			case 'credit':
				return `${baseRoute}/credits/${id}`;
			case 'customer':
				if (is_agent) {
					return `${baseRoute}/customer/${id}`
				}
				else {
					return `${baseRoute}`
				}
			case 'job':
				return `${baseRoute}/jobs/${id}`
			case 'project':
				return `${baseRoute}/project/${id}`;
			case 'addresses':
				if (is_agent) {
					return `${baseRoute}/customer/${id}/addresses`
				}
				else {
					return `${baseRoute}/addresses`
				}
		}
	}

	const isUser = () => {
		if (user.role == 'Private' || user.role == 'Business') return true;

		return false;
	}

	const superUser = () => {
		if (agentReducer?.user_state == 'SuperUser') {
			return true;
		}
		else if (agentReducer?.user_state == 'User' || agentReducer?.user_state == 'Agent') {
			return false
		}
		else {
			return ['2', '3', /* 4 */].reduce(id => id == user.id);
		}
	}

	const getUserName = () => {
		return user?.name ? user.name : '';
	}

	const getUser = () => {
		return user;
	}

	const getDefaultAccount = () => {
		return linkedAccounts?.default || false;
	}



	return {
		getRoute,
		selectedAccount,
		getUserName,
		setSelectedAccount,
		handleRadioChange,
		submitDefaultAccount,
		hasDefaultAccount,
		openAccountModal,
		resendVerificationLink,
		isUser,
		isAgent,
		is_agent,
		superUser,
		handleLogout,
		isAuthenticated,
		user,
		defaultAccount,
		linkedAccounts,
		getUser,
		getDefaultAccount,
		preferencesReady,
		systemPreferencesReady
	}
}

export default useAuth;